import React from "react";

export default function Carrinho({
  cartItems,
  open,
  onClose,
  onQuantityChange,
  onRemoveItem,
  onClearCart,
  onFinalize,
}) {
  const total = cartItems.reduce(
    (acc, item) => acc + item.preco * item.quantidade,
    0,
  );
  const qtdItens = cartItems.length;

  return (
    <>
      <aside
        className={`painel-carrinho ${open ? "ativo" : ""}`}
        aria-label="Carrinho de compras"
      >
        <div className="carrinho-cabecalho">
          <h2 className="carrinho-titulo">Seu Pedido</h2>
          <button
            className="carrinho-fechar"
            type="button"
            onClick={onClose}
            aria-label="Fechar carrinho"
          >
            ✕
          </button>
        </div>
        <div className="carrinho-itens" id="itensCarrinho">
          {cartItems.length === 0 ? (
            <div className="carrinho-vazio">
              <div className="carrinho-vazio-icone">◈</div>
              <p>Seu carrinho está vazio</p>
              <p style={{ fontSize: "0.7rem", opacity: 0.6 }}>
                Explore o catálogo e adicione produtos
              </p>
            </div>
          ) : (
            cartItems.map((item) => {
              const temFoto = item.fotos && item.fotos.length > 0;
              const imagemSrc = temFoto ? item.fotos[0] : null;
              return (
                <div key={item.id} className="item-carrinho">
                  <div className="item-carrinho-img">
                    {imagemSrc ? (
                      <img src={imagemSrc} alt={item.nome} />
                    ) : (
                      item.icone
                    )}
                  </div>
                  <div>
                    <div className="item-carrinho-nome">{item.nome}</div>
                    <div className="item-carrinho-cat">
                      {item.categoriaLabel}
                    </div>
                    <div className="item-carrinho-preco">
                      {(item.preco * item.quantidade).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <div className="controle-quantidade">
                      <button
                        type="button"
                        className="btn-qtd"
                        onClick={() => onQuantityChange(item.id, -1)}
                      >
                        −
                      </button>
                      <span className="qtd-display">{item.quantidade}</span>
                      <button
                        type="button"
                        className="btn-qtd"
                        onClick={() => onQuantityChange(item.id, 1)}
                      >
                        +
                      </button>
                    </div>
                    <button
                      type="button"
                      className="btn-remover-item"
                      onClick={() => onRemoveItem(item.id)}
                      title="Remover"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div
          className="carrinho-rodape"
          id="rodapeCarrinho"
          style={{ display: cartItems.length > 0 ? "block" : "none" }}
        >
          <div className="carrinho-resumo">
            <div className="resumo-linha">
              <span>Itens no pedido</span>
              <span id="resumoItens">
                {qtdItens} {qtdItens === 1 ? "item" : "itens"}
              </span>
            </div>
            <div className="resumo-linha total">
              <span>Total</span>
              <span id="resumoTotal">
                {total.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </span>
            </div>
          </div>
          <button type="button" className="btn-finalizar" onClick={onFinalize}>
            Finalizar compra
          </button>
          <button type="button" className="btn-limpar" onClick={onClearCart}>
            Limpar carrinho
          </button>
        </div>
      </aside>
      <div
        className={`fundo-escuro ${open ? "ativo" : ""}`}
        onClick={onClose}
      />
    </>
  );
}
